var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('sidebar')}}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }